import { createAction, props } from '@ngrx/store';

import { AdminVolumetryWidget, EntityVolumetry } from './bckp.state';

// ── Widget ────────────────────────────────────────────────────────────────────

export const BackBckpWidgetRequested = createAction(
    '[BACK-BCKP] Back Bckp Widget Requested',
    props<{ offset: number }>()
);
export const BackBckpWidgetSucceeded = createAction(
    '[BACK-BCKP] Back Bckp Widget Succeeded',
    props<{ widget: AdminVolumetryWidget }>()
);
export const BackBckpWidgetFailed = createAction(
    '[BACK-BCKP] Back Bckp Widget Failed'
);

// ── Detail Volumetry────────────────────────────────────────────────────────────────────

export const BackBckpDetailRequested = createAction(
    '[BACK-BCKP] Back Bckp Detail Requested',
    props<{ months: number }>()
);
export const BackBckpDetailSucceeded = createAction(
    '[BACK-BCKP] Back Bckp Detail Succeeded',
    props<{ entities: EntityVolumetry[], months: string[] }>()
);
export const BackBckpDetailFailed = createAction(
    '[BACK-BCKP] Back Bckp Detail Failed'
);
